import React from 'react';
import {
  FDTableHead, FDTableRow, FDTableCell, FDCheckboxInput,
} from '@facet-wealth/design';
import moment from 'moment/moment';

export default function DocumentsTableRow({
  resource,
  fields,
  onClick,
  checked,
  indeterminate,
  onCheckedChange,
}) {
  const header = !resource;
  const RootComponent = header ? FDTableHead : FDTableRow;

  function getValue(field) {
    const value = resource.attr(field.attr('name'));

    if (field.attr('type') === 'date') {
      return moment(value).local().format('ll');
    }
    return value;
  }

  return <>
    <RootComponent onClick={onClick} hover>
      <FDTableCell>
        <span
          onKeyDown={() => {}}
          role="checkbox"
          aria-checked="false"
          tabIndex="0"
          onClick={(ev) => {
            ev.stopPropagation();
          }}
        >
          <FDCheckboxInput
            checked={checked}
            indeterminate={indeterminate}
            onChange={onCheckedChange}
          />
        </span>
      </FDTableCell>
      {fields.map(field => (
        <FDTableCell key={field.attr('name')} align={field.attr('type') === 'number' ? 'right' : 'left'}>
          {header ? field.attr('prompt') : getValue(field)}
        </FDTableCell>))}
    </RootComponent>
  </>;
}
